module.exports = __webpack_public_path__ + "static/walk_site_header_image-d34673892bd0b9b40527cd76e183d8c7.png";